import { SuccessSVG } from "assets";
import { birthday2Age } from "helper/common";
import React from "react";
import { FIELD_TYPE } from "types/enums";
import "./ParaclinicalTest.scss"


const { INPUT, SELECT, DATE, CODE, COMBO_BOX } = FIELD_TYPE;

const dataField: any[] = [
  {
    type: SELECT,
    label: "Sổ CLS",
    name: "loaiSoKham",
    placeholder: "Chọn",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    options: [
      {value: 0, label: "Số nước tiểu"},
      {value: 1, label: "Sổ sinh hoá + huyết học"},
      {value: 2, label: "Sổ đông máu + test nhanh"},
    ],
  },
  {
    type: SELECT,
    label: "Bác sĩ chỉ định",
    name: "bacSyChiDinh",
    placeholder: "Chọn",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    options: [
      {value: "Nguyễn Thị Mai Phương", label: "Nguyễn Thị Mai Phương"},
      {value: "Đàm Văn Quý", label: "Đàm Văn Quý"},
      {value: "Nguyễn Thị Thu Hương", label: "Nguyễn Thị Thu Hương"},
      {value: "Đỗ Thị Liên", label: "Đỗ Thị Liên"},
      {value: "Hoàng Thị Hạnh", label: "Hoàng Thị Hạnh"},
      {value: "Nguyễn Lê Ngọc Khanh", label: "Nguyễn Lê Ngọc Khanh"},
      {value: "Nguyễn Thị Phương", label: "Nguyễn Thị Phương"},
      {value: "La Kim Luân", label: "La Kim Luân"},
    ],
  },
  {
    type: DATE,
    label: "Thời gian từ",
    name: "ngayTaoTu",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
  },
  {
    type: DATE,
    label: "Thời gian tới",
    name: "ngayTaoDen",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
  },
  {
    type: SELECT,
    label: "BHYT",
    name: "trangThaiBH",
    placeholder: "Chọn",
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 12,
      xs: 24,
    },
    labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    options: [
      {value: null, label: "Tất cả"},
      {value: 0, label: "Có"},
      {value: 1, label: "Không"},
    ],
  },
]

const columnsTable: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    //render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Barcode",
    dataIndex: "maBenhPham",
    key: "maBenhPham",
    width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "hoTen",
    key: "hoTen",
    // width: '8%',
    align: "left",
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    key: "tuoi",
    align: "center",
    render: (text, record: { ngaySinh: Date }) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    // children: [
    //   {
    //     title: 'Nam',
    //     dataIndex: 'nam',
    //     key: 'nam',
    //     render: (text, record) => {
    //       if (record.gioiTinh === 0) {
    //         return record.tuoi || ""; 
    //       } else {
    //         return "";
    //       }
    //     },
    //     // width: 100,
    //   },
    //   {
    //     title: 'Nữ',
    //     dataIndex: 'nu',
    //     key: 'nu',
    //     render: (text, record) => {
    //       if (record.gioiTinh === 1) {
    //         return record.tuoi || ""; 
    //       } else {
    //         return ""; 
    //       }
    //     },
    //     // width: 100,
    //   },
    // ],
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '6%',
    align: "left",
    render: (gioiTinh) => {
      if (gioiTinh == 0) return <span>Nam</span>;
      else if (gioiTinh == 1) return <span>Nữ</span>;
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    align: "left",
  },
  {
    title: "Có BHYT",
    dataIndex: "trangThaiBH",
    key: "trangThaiBH",
    align: "center",
    render: trangThaiBH => {
      // if (ttbh == 0) return <SuccessSVG />;
      if (trangThaiBH == 1) {
        return <div>Có</div>
      }
      else {
        return <div>Không</div>
      } 
    },
  },
  {
    title: "Phòng chỉ định",
    dataIndex: "phongChiDinh",
    key: "phongChiDinh",
    align: "right",
    
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    // width: '10%',
    align: "center",
    
  },
  {
    title: "Chẩn đoán",
    dataIndex: "chanDoan",
    key: "chanDoan",
    // width: '10%',
    align: "left",
  },
  
  {
    title: "Khoa chỉ định",
    dataIndex: "khoaChiDinh",
    key: "khoaChiDinh",
    // width: '10%',
    align: "left",
  },
  {
    title: "Ngày thực hiện",
    dataIndex: "ngayThucHien",
    key: "ngayThucHien",
    // width: '10%',
    align: "center",
  },
  {
    title: "Người thực hiện",
    dataIndex: "nguoiThucHien",
    key: "nguoiThucHien",
    // width: '10%',
    align: "left",
  },
  {
    title: "Thời gian in",
    dataIndex: "thoiGianIn",
    key: "thoiGianIn",
    // width: '10%',
    align: "center",
  },
];

const columnsTableNT: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    //render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Barcode",
    dataIndex: "maBenhPham",
    key: "maBenhPham",
    width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "hoTen",
    key: "hoTen",
    // width: '8%',
    align: "left",
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    key: "tuoi",
    align: "center",
    render: (text, record: { ngaySinh: Date }) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    // children: [
    //   {
    //     title: 'Nam',
    //     dataIndex: 'nam',
    //     key: 'nam',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nam") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return "";
    //       }
    //     },
    //     // width: 100,
    //   },
    //   {
    //     title: 'Nữ',
    //     dataIndex: 'nu',
    //     key: 'nu',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nu") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return ""; 
    //       }
    //     },
    //     // width: 100,
    //   },
    // ],
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '6%',
    align: "left",
    render: (gioiTinh) => {
      if (gioiTinh == 0) return <span>Nam</span>;
      else if (gioiTinh == 1) return <span>Nữ</span>;
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    align: "left",
  },
  {
    title: "Có BHYT",
    dataIndex: "trangThaiBH",
    key: "trangThaiBH",
    align: "center",
    render: trangThaiBH => {
      // if (ttbh == 0) return <SuccessSVG />;
      if (trangThaiBH == 1) {
        return <div>Có</div>
      }
      else {
        return <div>Không</div>
      } 
    },
  },
  {
    title: "Phòng chỉ định",
    dataIndex: "phongChiDinh",
    key: "phongChiDinh",
    align: "left",
    
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    // width: '10%',
    align: "center",
    
  },
  {
    title: "Chẩn đoán",
    dataIndex: "chanDoan",
    key: "chanDoan",
    // width: '10%',
    align: "left",
  },
  
  {
    title: "Khoa chỉ định",
    dataIndex: "khoaChiDinh",
    key: "khoaChiDinh",
    // width: '10%',
    align: "left",
  },
  {
    title: "Ngày thực hiện",
    dataIndex: "ngayThucHien",
    key: "ngayThucHien",
    // width: '10%',
    align: "center",
  },
  {
    title: "Người thực hiện",
    dataIndex: "nguoiThucHien",
    key: "nguoiThucHien",
    // width: '10%',
    align: "left",
  },
  {
    title: "Thời gian in",
    dataIndex: "thoiGianIn",
    key: "thoiGianIn",
    // width: '10%',
    align: "center",
  },
  {
    title: "UBG ( UROBILINOGEN )",
    dataIndex: "urg",
    key: "urg",
    // width: '10%',
    align: "center",
  },
  {
    title: "BIL ( BILIRUBIN )",
    dataIndex: "bil",
    key: "bil",
    // width: '10%',
    align: "center",
  },
  {
    title: "KET ( KETONE )",
    dataIndex: "ket",
    key: "ket",
    // width: '10%',
    align: "center",
  },
  {
    title: "BLD ( BLOOD )",
    dataIndex: "bld",
    key: "bld",
    // width: '10%',
    align: "center",
  },
  {
    title: "PRO ( PROTEIN )",
    dataIndex: "pro",
    key: "pro",
    // width: '10%',
    align: "center",
  },
  {
    title: "NIT (NITRITE )",
    dataIndex: "nit",
    key: "nit",
    // width: '10%',
    align: "center",
  },
  {
    title: "LEU ( LEUKOCYTES )",
    dataIndex: "leu",
    key: "leu",
    // width: '10%',
    align: "center",
  },
  {
    title: "GLU ( GLUCOSE )",
    dataIndex: "glu",
    key: "glu",
    // width: '10%',
    align: "center",
  },
  {
    title: "SG ( SPECIFIC GRAVITY )",
    dataIndex: "sg",
    key: "sg",
    // width: '10%',
    align: "center",
  },
  {
    title: "pH",
    dataIndex: "ph",
    key: "ph",
    // width: '10%',
    align: "center",
  },
  
];

const columnsTableHH: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    //render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Barcode",
    dataIndex: "maBenhPham",
    key: "maBenhPham",
    width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "hoTen",
    key: "hoTen",
    // width: '8%',
    align: "left",
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    key: "tuoi",
    align: "center",
    render: (text, record: { ngaySinh: Date }) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    // children: [
    //   {
    //     title: 'Nam',
    //     dataIndex: 'nam',
    //     key: 'nam',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nam") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return "";
    //       }
    //     },
    //     // width: 100,
    //   },
    //   {
    //     title: 'Nữ',
    //     dataIndex: 'nu',
    //     key: 'nu',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nu") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return ""; 
    //       }
    //     },
    //     // width: 100,
    //   },
    // ],
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '6%',
    align: "center",
    render: (gioiTinh) => {
      if (gioiTinh == 0) return <span>Nam</span>;
      else if (gioiTinh == 1) return <span>Nữ</span>;
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    align: "left",
  },
  {
    title: "Có BHYT",
    dataIndex: "trangThaiBH",
    key: "trangThaiBH",
    align: "center",
    render: trangThaiBH => {
      // if (ttbh == 0) return <SuccessSVG />;
      if (trangThaiBH == 1) {
        return <div>Có</div>
      }
      else {
        return <div>Không</div>
      } 
    },
  },
  {
    title: "Phòng chỉ định",
    dataIndex: "phongChiDinh",
    key: "phongChiDinh",
    align: "left",
    
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    // width: '10%',
    align: "center",
    
  },
  {
    title: "Chẩn đoán",
    dataIndex: "chanDoan",
    key: "chanDoan",
    // width: '10%',
    align: "left",
  },
  
  {
    title: "Khoa chỉ định",
    dataIndex: "khoaChiDinh",
    key: "khoaChiDinh",
    // width: '10%',
    align: "left",
  },
  {
    title: "Ngày thực hiện",
    dataIndex: "ngayThucHien",
    key: "ngayThucHien",
    // width: '10%',
    align: "center",
  },
  {
    title: "Người thực hiện",
    dataIndex: "nguoiThucHien",
    key: "nguoiThucHien",
    // width: '10%',
    align: "left",
  },
  {
    title: "Thời gian in",
    dataIndex: "thoiGianIn",
    key: "thoiGianIn",
    // width: '10%',
    align: "center",
  },
  {
    title: "Định lượng Glucose [Máu]",
    dataIndex: "glucose",
    key: "glucose",
    // width: '8%',
    align: "center",
  },
  {
    title: "WBC ( số lượng bạch cầu)",
    dataIndex: "wbc",
    key: "wbc",
    // width: '8%',
    align: "center",
  },
  {
    title: "RBC ( số lượng tế bào hồng cầu )",
    dataIndex: "rbc",
    key: "rbc",
    // width: '8%',
    align: "center",
  },
  {
    title: "HGB ( lượng huyết sắc tố )",
    dataIndex: "hgb",
    key: "hgb",
    // width: '8%',
    align: "center",
  },
  {
    title: "HCT ( tỷ lệ HC/thể tích máu )",
    dataIndex: "hct",
    key: "hct",
    // width: '8%',
    align: "center",
  },
  {
    title: "MCV ( thể tích trung bình HC )",
    dataIndex: "mcv",
    key: "mcv",
    // width: '8%',
    align: "center",
  },
  {
    title: "MCH ( lượng HGB trung bình HC )",
    dataIndex: "mch",
    key: "mch",
    // width: '8%',
    align: "center",
  },
  {
    title: "MCHC (nồng độ HGB trung bình HC)",
    dataIndex: "mchc",
    key: "mchc",
    // width: '8%',
    align: "center",
  },
  {
    title: "PLT ( số lượng tiểu cầu )",
    dataIndex: "plt",
    key: "plt",
    // width: '8%',
    align: "center",
  },
  {
    title: "LYM % ( tỷ lệ % BC lympho )",
    dataIndex: "lymp",
    key: "lymp",
    // width: '8%',
    align: "center",
  },
  {
    title: "MXD% ( tỷ lệ pha trộn tế bào )",
    dataIndex: "mxdp",
    key: "mxdp",
    // width: '8%',
    align: "center",
  },
  {
    title: "NEUT % ( tỷ lệ % BC trung tính )",
    dataIndex: "neutp",
    key: "neutp",
    // width: '8%',
    align: "center",
  },
  {
    title: "LYM # ( số lượng BC lympho )",
    dataIndex: "lym",
    key: "lym",
    // width: '8%',
    align: "center",
  },
  {
    title: "MXD # ( số lượng pha trộn tế bào )",
    dataIndex: "mxd",
    key: "mxd",
    // width: '8%',
    align: "center",
  },
  {
    title: "NEUT # ( số lượng BC trung tính )",
    dataIndex: "neut",
    key: "neut",
    // width: '8%',
    align: "center",
  },
  
];

const columnsTableTN: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    ////render: (text, record, index) => index + 1,
    align: "center",
  },
  {
    title: "Barcode",
    dataIndex: "maBenhPham",
    key: "maBenhPham",
    width: '100px',
    align: "center",
  },
  {
    title: "Tên bệnh nhân",
    dataIndex: "hoTen",
    key: "hoTen",
    // width: '8%',
    align: "left",
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    key: "tuoi",
    align: "center",
    render: (text, record: { ngaySinh: Date }) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    // children: [
    //   {
    //     title: 'Nam',
    //     dataIndex: 'nam',
    //     key: 'nam',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nam") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return "";
    //       }
    //     },
    //     // width: 100,
    //   },
    //   {
    //     title: 'Nữ',
    //     dataIndex: 'nu',
    //     key: 'nu',
    //     render: (text, record) => {
    //       if (record.gioiTinh === "nu") {
    //         return record.tuoi || ""; 
    //       } else {
    //         return ""; 
    //       }
    //     },
    //     // width: 100,
    //   },
    // ],
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    key: "gioiTinh",
    // width: '6%',
    align: "center",
    render: (gioiTinh) => {
      if (gioiTinh == 0) return <span>Nam</span>;
      else if (gioiTinh == 1) return <span>Nữ</span>;
    },
  },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    key: "diaChi",
    align: "left",
  },
  {
    title: "Có BHYT",
    dataIndex: "trangThaiBH",
    key: "trangThaiBH",
    align: "center",
    render: trangThaiBH => {
      // if (ttbh == 0) return <SuccessSVG />;
      if (trangThaiBH == 1) {
        return <div>Có</div>
      }
      else {
        return <div>Không</div>
      } 
    },
  },
  {
    title: "Phòng chỉ định",
    dataIndex: "phongChiDinh",
    key: "phongChiDinh",
    align: "left",
    
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuong",
    key: "doiTuong",
    // width: '10%',
    align: "center",
  },
  {
    title: "Chẩn đoán",
    dataIndex: "chanDoan",
    key: "chanDoan",
    // width: '10%',
    align: "left",
  },
  
  {
    title: "Khoa chỉ định",
    dataIndex: "khoaChiDinh",
    key: "khoaChiDinh",
    // width: '10%',
    align: "left",
  },
  {
    title: "Ngày thực hiện",
    dataIndex: "ngayThucHien",
    key: "ngayThucHien",
    // width: '10%',
    align: "center",
  },
  {
    title: "Người thực hiện",
    dataIndex: "nguoiThucHien",
    key: "nguoiThucHien",
    // width: '10%',
    align: "left",
  },
  {
    title: "Thời gian in",
    dataIndex: "thoiGianIn",
    key: "thoiGianIn",
    // width: '10%',
    align: "center",
  },
  {
    title: "PT(%)",
    dataIndex: "pt",
    key: "pt",
    // width: '8%',
    align: "center",
  },
  {
    title: "PT (INR)",
    dataIndex: "ptp",
    key: "ptp",
    // width: '8%',
    align: "center",
  },
  {
    title: "PT (s)",
    dataIndex: "pts",
    key: "pts",
    // width: '8%',
    align: "center",
  },
  {
    title: "APTT",
    dataIndex: "aptt",
    key: "aptt",
    // width: '8%',
    align: "center",
  },
  {
    title: "APTT (b/c)",
    dataIndex: "aptt2",
    key: "aptt2",
    // width: '8%',
    align: "center",
  },
  {
    title: "HIV Ab test nhanh",
    dataIndex: "hivAb",
    key: "hivAb",
    // width: '8%',
    align: "center",
  },
  {
    title: "HBsAg test nhanh",
    dataIndex: "hbsAg",
    key: "hbsAg",
    // width: '8%',
    align: "center",
  },
  
];

export { dataField, columnsTable, columnsTableNT, columnsTableHH, columnsTableTN };
